<template>
    <MainContent
        title="Agrupar precios"
        format="card"
    >
        <template slot="header">
            <h4 class="card-title">Listado de grupos</h4>
            <div class="card-tools">
                <CreateModal
                    @creado="getGrupos()"
                />
            </div>
        </template>
        <template slot="content">
            <b-row>
                <b-col cols="12">
                    <b-table
                        :items="grupos.data"
                        :fields="fields"
                        :show-empty="true"
                        :busy="loading"
                    >
                        <template #empty="">
                            <h5 class="text-center">No hay ningún grupo disponible.</h5>                                               
                        </template>
                        <template #table-busy>
                            <div class="text-center my-2">
                                <b-spinner class="align-middle"/>
                            </div>
                        </template>
                        <template #cell(opciones)="data">
                            <OpcionesDropdownComponent
                                :options="[
                                    { type: 'action', label: 'Editar', action: () => showEditModal(data.item) },
                                    { type: 'action', label: 'Borrar', action: () => showDeleteConfirm(data.item) },
                                    { to: { name: 'back.abonos.precios.grupos.show', params: { grupo_id: data.item.id } }, label: 'Ver precios' }
                                ]"
                            />
                            <EditModalComponent
                                :name="'edit-modal-' + data.item.id"
                                :grupo="grupoSeleccionado"
                                :title="'Edición del grupo ' + data.item.name"
                                @close="$modal.hide('edit-modal-' + data.item.id)"
                                @editado="getGrupos()"
                            />
                            <BorrarModalComponent
                                :name="'delete-modal-' + data.item.id"
                                :borrarTitle="'¿Seguro que quieres borrar el siguiente grupo?'"
                                :title="'Confirmación'"
                                :confirmButton="data.item.name"
                                @close="$modal.hide('delete-modal-' + data.item.id)"
                                @confirm="! loading ? borrarGrupo(data.item.id) : null"
                            />
                        </template>
                    </b-table>
                    <div class="row">
                        <div class="col-12 col-lg-3" v-if="grupos.data">
                            <PaginateComponent
                                :current_page="grupos.meta.current_page"
                                :last_page="grupos.meta.last_page"
                                v-on:change_page="setPage"
                            />
                        </div>
                    </div>
                </b-col>
            </b-row>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from '@/components/backend/components/MainContent.vue'
    import CreateModal from './modals/CreateModal.vue';
    import OpcionesDropdownComponent from '@/components/backend/components/OpcionesDropdownComponent.vue';
    import BorrarModalComponent from '@/components/backend/components/BorrarModalComponent.vue';
    import EditModalComponent from './modals/EditModal.vue';
    import PaginateComponent from "@/components/table/pagination/BackPaginateComponent";

    export default {
        data() {
            return {
                grupos: {
                    data: []
                },
                fields: [
                    {
                        key: 'name',
                        label: 'Nombre',
                        align: 'center'
                    },
                    {
                        key: 'description',
                        label: 'Descripción'
                    },
                    {
                        key: 'opciones',
                        label: 'Opciones'
                    },
                ],
                loading: false,
                grupoSeleccionado: {},
                rows: 1,
                filters: {
                    per_page: 15,
                    page: 1,
                    search: ''
                },
            }
        },
        created() {
            this.getGrupos();
        },
        methods: {
            getGrupos() {
                this.loading = true;
                const params = {
                    filters : this.filters,
                    lista_id: this.$store.getters.getListaId
                };

                this.$store.dispatch(this.config.getVuexAlias('back.precios.grupos'), params).then(res => {
                    this.rows = res.data.meta.last_page;
                    this.grupos = res.data;
                    this.loading = false;
                });
            },
            borrarGrupo(grupo_id) {
                const params = {
                    filters : this.filters,
                    lista_id: this.$store.getters.getListaId,
                    grupo_id: grupo_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.precios.grupos.borrar'), params).then(res => {
                    this.getGrupos();
                });
            },
            showEditModal(grupo) {
                this.grupoSeleccionado = grupo;
                this.$modal.show('edit-modal-' + grupo.id);
            },
            showDeleteConfirm(grupo) {
                this.$modal.show('delete-modal-' + grupo.id)
            },
            setPage(page) {
                this.filters.page = page;
                this.getGrupos();
            },
        },
        components: {
            MainContent, CreateModal, OpcionesDropdownComponent, BorrarModalComponent, PaginateComponent, EditModalComponent
        }
    }
</script>